module.exports = __webpack_public_path__ + "img/RDA_tipo3_8pax_90m2.41481e1f.png";